import { is2xxStatus } from './AlertMessageLogic'

export default function messageOnInviteNewDeveloper(status, info) {
    let message

    if (is2xxStatus(status)) status = '2xx'

    switch (status) {
        case 503:
            message = 'Ops! Ocorreu um problema com a internet e não conseguimos convidar um novo desenvolvedor.'
            break
        case '2xx':
            message = 'Convidamos o desenvolvedor.'
            break
        case 401:
            message = 'Ops! O seu tempo de acesso expirou, para enviar o convite é necessário realizar o login.'
            break
        case 403:
            message = 'Você não possui privilégios para enviar convites para este Mini App.'
            break
        case 409:
            message = `O usuário ${info.email} já é um desenvolvedor do Eitri-App ${info.miniApp}.`
            break
        case 'invalid':
            message = 'Por favor, Digite um email válido.'
            break
        default:
            message = 'Ops! Algo estranho ocorreu e não realizamos o convite. Por favor, tente novamente mais tarde.'
    }

    return message
}
